import React from "react";
import contentfulDelivery, { FullBlog } from "server/contentful-delivery";
import BlogPage from "modules/marketing-pages/blog-page";
import { buildTOCItems, toEffectiveTocItems } from "components/blog/utils";
import toc from "markdown-toc";
import { EffectiveTOCItem } from "components/blog/types";
import { isCn } from "client-server-shared/constants";
import { blogRouteBySlug } from "client-server-shared/config/routes";
import { getAllPosts, getPostByIdOrSlug } from "server/blog-client";

const BlogContext = React.createContext(null);

const useBlogContext = () => React.useContext(BlogContext)!;

const BlogPostPage = ({
  article,
  toc,
}: {
  article: FullBlog;
  toc: EffectiveTOCItem[];
}) => {
  return (
    <BlogContext.Provider value={article}>
      <BlogPage toc={toc} article={article} />
    </BlogContext.Provider>
  );
};

export async function getStaticProps({ params }) {
  const article = await getPostByIdOrSlug(params.slugOrLang);
  if (!article) {
    return {
      notFound: true,
    };
  }
  if (article.language !== "English") {
    return {
      redirect: {
        destination: blogRouteBySlug(article.slug, article.language),
        permanent: true,
      },
    };
  }
  return {
    props: {
      article: article,
      toc: buildTOCItems(toEffectiveTocItems(toc(article.markdown!).json)),
    },
    revalidate: 3600,
  };
}

export async function getStaticPaths() {
  const slugs = await getAllPosts();

  const paths = slugs
    .filter((slug) => slug.language === "English")
    .map((slug) => ({
      params: {
        slugOrLang: slug.slug,
      },
    }));
  return {
    paths,
    fallback: "blocking",
  };
}

export default BlogPostPage;
